<template>
  <div class="cashflow-category-menu-items">
    <card-menu-item item-key="info"
                    v-if="showInfoPopups"
                    :onItemClick="emitOpenSectionInfoPopup"
                    :icon-src="require(`@/assets/${infoMenuItemIcon}`)"
                    :text="infoMenuItemText"/>
    <card-menu-item item-key="info"
                    v-if="showCategoryTrends"
                    :onItemClick="emitOpenTrend"
                    :icon-src="require(`@/assets/${trendsMenuItemIcon}`)"
                    :text="trendsMenuItemText"/>
    <card-menu-item item-key="edit"
                    v-if="canEdit"
                    :onItemClick="emitOpenEditTrackingCategoryAmountPopup"
                    :icon-src="require('@/assets/icons/gray-pencil.svg')"
                    text="עריכת סכום"/>
    <card-menu-item item-key="delete"
                    v-if="canEdit"
                    :onItemClick="emitOpenCancelTrackingCategoryConfirmationPopup"
                    :icon-src="require('@/assets/icons/gray-trash.svg')"
                    text="מחיקה מהתזרים"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import cashflowViewConsts from '@/constants/cashflow-view';
import BaseUI from 'base-ui';
import EditAmountPopup from '../EditAmountPopup';
import Segment from '../../../../../../../../../../Segment';
import CancelTrackingCategoryConfirmationPopup from './CancelTrackingCategoryConfirmationPopup.vue';
import TrackingCategoryInfoPopup from '../../../../info-popups/TrackingCategoryInfoPopup';
import InfoPopups from '../../../../info-popups/InfoPopups';
import TrackingCategoryCashflowTrend from '../../../../cashflow-trend/TrackingCategoryCashflowTrend';
import CashflowTrends from '../../../../cashflow-trend/CashflowTrendsMixin';
import { TREND_COMPONENTS } from '../../../../cashflow-trend/cashflow-trends';

export default {
  name: 'CashflowCategorySectionMenu',
  components: {
    CardMenuItem: BaseUI.CardMenuItem,
  },
  mixins: [InfoPopups, CashflowTrends],
  props: {
    cardTypeId: {
      type: String,
      required: true,
    },
    subTree: {
      type: Object,
      required: false,
    },
    category: {
      type: Object,
      required: false,
    },
    showInfoPopups: {
      type: Boolean,
      required: true,
    },
    showCategoryTrends: {
      type: Boolean,
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    categoryName() {
      return this.subTree ? this.subTree.categoryName : undefined;
    },
    envelopeId() {
      return this.subTree ? this.subTree.envelopeId : undefined;
    },
    upToNowAmount() {
      return this.subTree ? this.subTree.upToNowAmount : undefined;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    emitOpenSectionInfoPopup() {
      if (this.INFO_COMPONENTS[this.cardTypeId]) {
        this.trackInfoPopupClicked(this.cardTypeId);
        this.openModal({
          component: this.INFO_COMPONENTS[this.cardTypeId],
          props: { subTree: this.subTree },
        });
      } else {
        this.trackInfoPopupClicked(cashflowViewConsts.cashflowTypes.trackingCategory);
        this.openModal({
          component: TrackingCategoryInfoPopup,
          props: { subTree: this.subTree },
        });
      }
    },
    emitOpenTrend() {
      if (TREND_COMPONENTS[this.cardTypeId]) {
        this.openModal({ component: TREND_COMPONENTS[this.cardTypeId] });
      } else {
        this.openModal({
          component: TrackingCategoryCashflowTrend,
          props: { categoryId: this.category.categoryId },
        });
      }
    },
    emitOpenCancelTrackingCategoryConfirmationPopup() {
      Segment.trackUserInteraction('SectionMenu_CancelTrackingCategoryClicked', {
        trackingCategory: this.categoryName,
      });
      this.openModal({
        component: CancelTrackingCategoryConfirmationPopup,
        props: {
          trackingCategory: this.categoryName,
          categoryId: this.category.categoryId,
          envelopeId: this.envelopeId,
          upToNowAmount: this.upToNowAmount,
        },
      });
    },
    emitOpenEditTrackingCategoryAmountPopup() {
      Segment.trackUserInteraction('SectionMenu_EditTrackingCategoryAmountClicked', {
        trackingCategory: this.categoryName,
      });
      this.openModal({
        component: EditAmountPopup,
        props: {
          expenseCategory: this.categoryName,
          category: this.category,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.cashflow-category-menu-items {
  display: contents;
}

</style>
